import fetcher from 'features/shared/utils/fetcher'

async function getTermsConditions(patientId:number) {
  return await fetcher.get('/terms-conditions/'+patientId)

}

export default getTermsConditions
